export default function data() {
  return {
    targets: [
      {
        path: "/qHyperCubeDef",
        dimensions: {
          min: 1,
          max: 1,
        },
        measures: {
          min: 1,
          max: 1,
        },
      },
    ],
  };
}
